import request from '@/utils/request'

/**
 * 获取充值记录列表
 */
export function getRechargeList(params) {
  return request({
    url: '/biz/user/recharge/list',
    method: 'get',
    params
  })
}

/**
 * 退充值
 */
export function refundRecharge(data) {
  return request({
    url: '/biz/user/recharge/refund',
    method: 'post',
    data
  })
}
